import styles from './Footer.module.scss';

const Footer = (): JSX.Element => {
  const currentYear = new Date().getFullYear();

  return <div className={styles.wrapper}>© SnapInsight Administration {currentYear}</div>;
};

export default Footer;
